import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Contactinfo extends Component {
    render() {
        return (
            <div className="row mb-xl-80">
                <div className="col-lg-4 col-sm-6">
                    <div className="contact-info mb-xl-30">
                        <div className="icon-box"> <i className="fas fa-phone" /> </div>
                        <div className="contact-text">
                            <label className="text-custom-black fs-18 fw-600">Phone No.</label>
                            <a rel={"external"} href="tel:" className="text-light-white fs-14">(+123) 123 4567 890</a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                    <div className="contact-info mb-xl-30">
                        <div className="icon-box"> <i className="far fa-envelope" /> </div>
                        <div className="contact-text">
                            <label className="text-custom-black fs-18 fw-600">Email Id</label>
                            <a rel={"external"} href="mailto:" className="text-light-white fs-14">example@example.com</a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                    <div className="contact-info mb-xl-30">
                        <div className="icon-box"> <i className="fas fa-map-marker-alt" /> </div>
                        <div className="contact-text">
                            <label className="text-custom-black fs-18 fw-600">Address</label>
                            <Link to="#" className="text-light-white fs-14">Los Angeles, (USA)</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                    <div className="contact-info mb-md-30">
                        <div className="icon-box"> <i className="fas fa-fax" /> </div>
                        <div className="contact-text">
                            <label className="text-custom-black fs-18 fw-600">Fax</label>
                            <a rel={"external"} href="tel:" className="text-light-white fs-14">(+123) 123 4567 890</a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                    <div className="contact-info mb-md-30">
                        <div className="icon-box"> <i className="fas fa-phone" /> </div>
                        <div className="contact-text">
                            <label className="text-custom-black fs-18 fw-600">Telephone</label>
                            <a rel={"external"} href="tel:" className="text-light-white fs-14">(+123) 123 4567 890</a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-sm-6">
                    <div className="contact-info">
                        <div className="icon-box"> <i className="fas fa-comments" /> </div>
                        <div className="contact-text">
                            <label className="text-custom-black fs-18 fw-600">Comments</label>
                            <Link to="#" className="text-light-white fs-14">Los Angeles, (USA)</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Contactinfo;